// extracted by mini-css-extract-plugin
export default {"header":"MainNavigation_header__63yok","logo":"MainNavigation_logo__0hBXJ","active":"MainNavigation_active__SGAP4","privacyButton":"MainNavigation_privacyButton__QyQAN"};